export const MetaKeys = ['Tab', 'Backspace', 'Delete', 'Home', 'End', 'PageDown', 'PageUp', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
